import { StylesConfig } from 'react-select';
import { Option } from './index';

const selectStyles = (
  withRoundCorners: boolean = false
): StylesConfig<Option> => ({
  placeholder: (styles) => ({
    ...styles,
    fontFamily: 'Poppins',
    color: '#000000',
    whiteSpace: 'nowrap',
    fontWeight: 300,
    fontSize: 12,
    lineHeight: '14px',
  }),
  container: (styles) => ({
    ...styles,
    flex: 8,
    width: '100%',
  }),
  control: (styles, { isDisabled }) => ({
    ...styles,
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    border: '1px solid #8e8b84',
    borderRadius: withRoundCorners ? 100 : 0,
    flex: 1,
    justifyContent: 'space-around',
    boxShadow: 'none',
    minHeight: '35px',
    ':hover': {
      border: '1px solid #8e8b84',
    },
    cursor: 'pointer',
    ...(isDisabled && {
      opacity: 0.5,
      cursor: 'not-allowed',
    }),
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '33px',
  }),
  dropdownIndicator: (style) => ({
    ...style,
    strokeWidth: 0,
    color: '#8e8b84',
    ':hover': {},
  }),
  option: (style) => ({
    ...style,
    ':hover': {
      background: `#aad4d277`,
    },
  }),
  valueContainer: (styles) => ({
    ...styles,
    fontSize: 14,
    padding: '2px 0 2px 16px',
  }),
  menu: (style) => ({
    ...style,
    backgroundColor: 'white',
    boxShadow: '0px 10px 10px 10px rgba(182, 182, 182, 0.25)',
    borderWidth: 1,
    borderColor: '#8e8b84',
    borderStyle: 'solid',
    borderRadius: withRoundCorners ? 8 : 0,
    zIndex: 100,
    overflow: 'hidden',
  }),
});

export default selectStyles;
